module.exports = __webpack_public_path__ + "img/mbti-title.e0eba886.png";